import { useParams } from "@/lib/router"

export function useCurrentFinanceProjectId() {
	const { id } = useParams()

	return parseInt(id as string)
}
